<template>
  <div id="app">
    <v-app v-if="['logIn', 'listProductPage', 'listProductIntroPage'].indexOf($route.name) > -1">
      <div v-if="isLaptop">
        <header-backend-menu></header-backend-menu>
        <router-view
        :callDataProps="callData"
        :callIntroImage="callIntroImage"
        :graphData="graphData"
        :allData="data"
        :allUrl="url"
        :index_list="indexList"
        :isLapTopCheck="isLaptop">
        </router-view>
        <footer-menu></footer-menu>
      </div>
      <!-- mobile version -->
      <div v-else>
        <header-mobile-menu></header-mobile-menu>
        <router-view
        :callDataProps="callData"
        :callIntroImage="callIntroImage"
        :graphData="graphData"
        :allData="data"
        :allUrl="url"
        :index_list="indexList"
        :isLapTopCheck="isLaptop">
        </router-view>
        <footer-mobile-menu></footer-mobile-menu>
      </div>

    </v-app>

    <v-app v-else>
      <div v-if="isLaptop">
        <div v-if="['home', 'homePage'].indexOf($route.name) > -1">
          <header-menu></header-menu>
          <router-view
          :allData="data"
          :allUrl="url"
          :index_list="indexList"
          :data_by_category="dataByCategory"
          :popular_product="popularProduct"
          :normal_product="normalProduct"
          :productItem1="item1"
          :productItem2="item2"
          :productItem3="item3"
          :productItem4="item4"
          :productItem5="item5"
          :productItem6="item6"
          :productOther="other"
          :childData="childData"
          @update-child = "updateChild"
          :randomList = "randomList"
          :isLapTopCheck="isLaptop">
          </router-view>
          <footer-menu></footer-menu>
        </div>

        <div
          v-else
          class="hide-overflow"
          style="position: relative;"
        >
          <header-menu></header-menu>
          <div
            id="scrolling-techniques"
            class="scroll-y"
            style="max-height: 2000px;"
          >
            <router-view
            :allData="data"
            :allUrl="url"
            :index_list="indexList"
            :data_by_category="dataByCategory"
            :popular_product="popularProduct"
            :normal_product="normalProduct"
            :productItem1="item1"
            :productItem2="item2"
            :productItem3="item3"
            :productItem4="item4"
            :productItem5="item5"
            :productItem6="item6"
            :productOther="other"
            :childData="childData"
            @update-child = "updateChild"
            :randomList = "randomList"
            :isLapTopCheck="isLaptop"
            style="height: auto;">
            </router-view>
            <footer-menu></footer-menu>
          </div>
        </div>
      </div>

      <!-- mobile version -->
      <div v-else>
        <header-mobile-menu></header-mobile-menu>
        <router-view
        :allData="data"
        :allUrl="url"
        :index_list="indexList"
        :data_by_category="dataByCategory"
        :popular_product="popularProduct"
        :normal_product="normalProduct"
        :productItem1="item1"
        :productItem2="item2"
        :productItem3="item3"
        :productItem4="item4"
        :productItem5="item5"
        :productItem6="item6"
        :productOther="other"
        :childData="childData"
        @update-child = "updateChild"
        :randomList = "randomList"
        :isLapTopCheck="isLaptop">
        </router-view>
        <footer-mobile-menu></footer-mobile-menu>
      </div>

    </v-app>
  </div>
</template>
<script>
import HeaderMenu from './components/extra/header.vue'
import HeaderMobileMenu from './components/extra/headerMobile.vue'
import HeaderBackendMenu from './components/extra/headerBackend.vue'
import FooterMenu from './components/extra/footer.vue'
import FooterMobileMenu from './components/extra/footerMobile.vue'
import firebase from 'firebase'
export default {
  components: {
    HeaderMenu,
    FooterMenu,
    FooterMobileMenu,
    HeaderBackendMenu,
    HeaderMobileMenu
  },
  name: 'App',
  data () {
    return {
      childData: 'yoyo',
      isMobile: false,
      isLaptop: false,
      url: [],
      data: {},
      indexList: {},
      dataByCategory: {},
      popularProduct: {},
      normalProduct: {},
      item1: {},
      item2: {},
      item3: {},
      item4: {},
      item5: {},
      item6: {},
      other: {},
      graphData: []
    }
  },
  created () {
    this.callIntroImage()
    this.callData()
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    onResize () {
      this.isMobile = window.innerWidth < 600
      this.isLaptop = window.innerWidth > 1000 && window.innerWidth < 3000
    },
    updateChild (e) {
      this.childData = e
    },
    callIntroImage () {
      var allImages = []
      this.url = []
      var ref = firebase.database().ref()
      ref.on('value', function (images) {
        var databaseImageIntro = images.val().intro_images
        for (var key in databaseImageIntro) {
          // Create a reference to the file whose metadata we want to retrieve
          var ref = firebase.storage().refFromURL(databaseImageIntro[key].url)
          var getUrl = databaseImageIntro[key].url
          var getName = ref.name
          var allD = {
            url: getUrl,
            name: getName
          }
          allImages.push(allD)
        }
      }, function (error) {
        console.log('Error: ' + error.code)
      })
      this.url = allImages
    },
    callData () {
      this.data = {}
      this.indexList = {}
      this.dataByCategory = {}
      this.popularProduct = {}
      this.normalProduct = {}
      this.item1 = {}
      this.item2 = {}
      this.item3 = {}
      this.item4 = {}
      this.item5 = {}
      this.item6 = {}
      this.other = {}
      this.graphData = []
      // ------- use direction to keep data -------
      var dict = {}
      dict['allData'] = []
      dict['allIndex'] = []
      dict['popular'] = []
      dict['normal'] = []
      dict['item1'] = []
      dict['item2'] = []
      dict['item3'] = []
      dict['item4'] = []
      dict['item5'] = []
      dict['item6'] = []
      dict['other'] = []
      var ref = firebase.database().ref()
      ref.on('value', function (snapshot) {
        var databaseData = snapshot.val().product_id
        for (var key in databaseData) {
          var checkEachCategory = databaseData[key].category
          var checkEachStatus = databaseData[key].status
          // ---------- check that there is a key in dict or not
          var testCategoryArray = checkEachCategory in dict
          var testStatusArray = checkEachStatus in dict
          if (!testCategoryArray) {
            dict[checkEachCategory] = []
            dict[checkEachCategory].push(databaseData[key])
          } else {
            dict[checkEachCategory].push(databaseData[key])
          }
          if (!testStatusArray) {
            dict[checkEachStatus] = []
            dict[checkEachStatus].push(databaseData[key])
          } else {
            dict[checkEachStatus].push(databaseData[key])
          }
          dict['allData'].push(databaseData[key])
          dict['allIndex'].push(key)
        }
      }, function (error) {
        console.log('Error: ' + error.code)
      })
      this.dataByCategory = dict
      this.data = dict['allData']
      this.indexList = dict['allIndex']
      this.popularProduct = dict['popular']
      this.normalProduct = dict['normal']
      this.item1 = dict['item1']
      this.item2 = dict['item2']
      this.item3 = dict['item3']
      this.item4 = dict['item4']
      this.item5 = dict['item5']
      this.item6 = dict['item6']
      this.other = dict['other']
      this.countProduct(dict)
    },
    countProduct (dict) {
      var eachItem = ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'other', 'popular', 'normal']
      for (var item in eachItem) {
        this.graphData.push(dict[eachItem[item]].length)
      }
    },
    randomList (data, amount) {
      var finalList = []
      // becareful, loop forever!!!! have to check that data have data
      if (!(data === undefined || data.length === 0)) {
        // make sure that the length of data has more than 4
        if (data.length >= 4) {
          // --------------- for loop ---------------
          for (var i = 0; finalList.length < amount; i++) {
            var rand = data[Math.floor(Math.random() * data.length)]
            if (!finalList.includes(rand)) {
              finalList.push(rand)
            }
          }
        }
      }
      return finalList
    }
  }
}
</script>

<style media="screen">
#app {
  font-family: 'Kanit', sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue